<template>
    <div class="container">
        <h1>EINSATZBEREICHE</h1>
        <p>
            Die Einsatzbereiche der Master Mass Digital App sind sehr
            vielfältig. Von klassischen Fenstern und Türen über sämtliche
            Glaselemente im Innenausbau bis hin zu Duschtüren, Glasgeländern
            oder Küchenrückwänden können Sie mittels einfacher Vorlagen Ihre
            Maße in der App eingeben und direkt vom Produzenten bestellen.
            Veredelungen (eingefärbt / mit Wunschmotiv bedruckt) sind für nahezu
            alle Glassorten möglich.
        </p>
        <div class="container-slider">
            <img
                class="image"
                v-for="(image, i) in images"
                :src="image"
                :key="i"
                @click="index = i"
            />
            <vue-gallery-slideshow
                :images="images"
                :index="index"
                @close="index = null"
            />
        </div>
    </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";
export default {
    components: {
        VueGallerySlideshow
    },
    data() {
        return {
            images: [
                "/images/2020_mmd_facebook4.jpg",
                "/images/2020_mmd_facebook5.jpg",
                "/images/2020_mmd_facebook6.jpg",
                "/images/2020_mmd_facebook7.jpg",
                "/images/2020_mmd_facebook8.jpg",
                "/images/2020_mmd_facebook9.jpg",
                "/images/2020_mmd_facebook10.jpg",
                "/images/2020_mmd_facebook11.jpg"
            ],
            index: null
        };
    }
};
</script>





// WEBPACK FOOTER //
// resources/nuxt/pages/areas.vue